import React from 'react'
import { useState,useEffect } from 'react';
import GreenButton from '../../../components/forms/greenButton';
import BlueButton from '../../../components/forms/blueButton';
import RedButton from '../../../components/forms/redButton';
import { Link } from 'react-router-dom';
import {ReactComponent as DeleteIcon} from '../../../images/icons/delete.svg'
import {ReactComponent as ViewIcon} from '../../../images/icons/view.svg'
import {ReactComponent as EditIcon} from '../../../images/icons/edit.svg'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ApiUrl from '../../../configTools/apiUrl';
import ScreenSizes from '../../../configTools/screenSizes';

const Listing = () => {
    const User = JSON.parse(localStorage.getItem("user-info"));
    const [products,setProducts] = useState([]);

    const delete_admin = (id) =>{
      console.log(ApiUrl.API_URL_ListingDelete+"/"+id)
      if (window.confirm("This action will delete listing permanently.") === false) {
        return;
      }
      const toastid = toast.loading("Please wait ...",{ position: toast.POSITION.BOTTOM_CENTER});
      
      fetch(ApiUrl.API_URL_ListingDelete+"/"+id,{
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+User.token
        }
      })
      .then(res=>res.json())
      .then(data =>{
        console.log(data);
        if(data.success){
          toast.update(toastid, { render: "Deleted", type: "success", isLoading: false, autoClose:2000, position: toast.POSITION.BOTTOM_CENTER });
          fetch(ApiUrl.API_URL_ListingUser+"/"+User.username)
          .then(res=>res.json())
          .then(data2 =>{
              if(data2.success)
              setProducts(data2.responce);
          });
        }
        else{
          toast.update(toastid, { render: data.responce, type: "error", isLoading: false, autoClose:2000, position: toast.POSITION.BOTTOM_CENTER });
        }
      });
    }
  useEffect(() => {
    fetch(ApiUrl.API_URL_ListingUser+"/"+User.username)
    .then(res=>res.json())
    .then(data =>{
        if(data.success)
        setProducts(data.responce);
    });
  },[])
  const widths = window.innerWidth;
  return (
    <>
      <div className='listing_container'>
        <div className='public_home_product_grid_1_container'>
          <div className='public_home_product_grid_4_products'>
            {
                products.map((Product,index)=>{
                    return(
                        <div style={{width:String((100/(parseInt(widths > ScreenSizes.Mobile? 5 : 3))))+"%", padding:"0.1%"}} key={index}>
                          <div className='public_home_product_grid_1_products_item_container' style={{backgroundImage:`url(${ApiUrl.API_URL_Image_Collection+Product.image})`}}>
                              <div className='public_home_product_grid_1_products_item_overlay'>
                                  <div className='public_home_product_grid_1_products_item_overlay_price'>
                                      <div className='listing_bottom_buttons'>
                                        <Link to={'/product/'+Product.slug} target="_blank" rel="noopener noreferrer"><BlueButton Value={<ViewIcon width={'10px'} height={'10px'}/>}/></Link>
                                        <Link to={'/dashboard/listings/edit/'+Product.id}><GreenButton Value={<EditIcon width={'10px'} height={'10px'}/>}/></Link>
                                        <RedButton Value={<DeleteIcon width={'10px'} height={'10px'} />} Action={
                                          ()=>{
                                            delete_admin(Product.id);
                                          }
                                        }/>
                                      </div>
                                  </div>
                              </div>
                          </div>
                        </div>
                    )
                })
            }
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  )
}

export default Listing
